export const HISTORY_KEY = "bcView";

const RANGES = ["weekly", "monthly"];
const VIEWS = ["calendar", "occupancy"];

export function rememberedView(state) {
  const saved = state && state[HISTORY_KEY];
  if (!saved || !RANGES.includes(saved.range) || !VIEWS.includes(saved.view) || !/^\d{4}-\d{2}-\d{2}$/.test(String(saved.date))) return null;

  return { range: saved.range, date: saved.date, view: saved.view };
}

export function withRemembered(state, view) {
  return { ...(state || {}), [HISTORY_KEY]: { range: view.range, date: view.date, view: view.view } };
}

export function zoomEntries(state, monthly, weekly) {
  const next = withRemembered({}, weekly);
  if (state && state.turbolinks) next.turbolinks = { ...state.turbolinks };

  return { current: withRemembered(state, monthly), next };
}
